import { Navigate } from "react-router-dom";
import usePermissions from "../../hooks/usePermissions";
import { resolveHomePath } from "../lib/homePath";

/** Redirect `/` (and similar) to the best page for this role. */
const HomeRedirect = () => {
  const { permissions, isAdmin } = usePermissions();
  return <Navigate to={resolveHomePath(permissions, isAdmin)} replace />;
};

export default HomeRedirect;
